"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html } from "@custom/schema";
import { Tab, Transition } from "@headlessui/react";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { Fragment, useState } from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function TabbedInformation(props) {
    var _props_upperLevelTabs_;
    var _useState = _sliced_to_array(useState(props.upperLevelTabs[0]), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), lowerTabIndex = _useState1[0], setLowerTabIndex = _useState1[1];
    var _useState2 = _sliced_to_array(useState(((_props_upperLevelTabs_ = props.upperLevelTabs[0]) === null || _props_upperLevelTabs_ === void 0 ? void 0 : _props_upperLevelTabs_.id) || ""), 2), visibleParentId = _useState2[0], setVisibleParentId = _useState2[1];
    // Filters the lower level tabs associated with the upper parent tab
    // const filteredItems = props.lowerLevelTabs.filter(
    //   (lowerTab) => lowerTab?.parent === visibleParentId,
    // );
    var handleUpperTabClick = function(buttonId) {
        setVisibleParentId(buttonId);
    };
    // const handleNextTab = () => {
    //   setLowerTabIndex((prev) => (prev + 1) % filteredItems.length);
    // };
    //
    // const handlePrevTab = () => {
    //   setLowerTabIndex(
    //     (prev) => (prev - 1 + filteredItems.length) % filteredItems.length,
    //   );
    // };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 pb-24 lg:pb-64 relative mt-12 md:mt-24 lg:mt-28 overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative z-20"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto max-w-xs md:max-w-md lg:max-w-lg text-center block text-2xl md:text-3xl lg:text-4xl mb-10 md:mb-14"
    }, props.heading), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col overflow-hidden"
    }, /*#__PURE__*/ React.createElement("nav", {
        className: 'relative before:content-[""] before:block before:h-1 before:w-full before:bg-gray-10 before:absolute before:-bottom-px before:left-0'
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "flex w-full mx-auto max-w-4xl"
    }, props.upperLevelTabs.map(function(upperTab) {
        /*#__PURE__*/ return React.createElement("li", {
            key: upperTab === null || upperTab === void 0 ? void 0 : upperTab.id,
            onClick: function() {
                setSelectedTab(upperTab);
                setLowerTabIndex(0);
                handleUpperTabClick((upperTab === null || upperTab === void 0 ? void 0 : upperTab.id) || "");
            },
            className: clsx("w-full relative top-px text-center cursor-pointer hover:text-gray-600 border-b-4 font-heading flex justify-between items-center md:text-lg transition-all flex-1", {
                "bg-yellow-100 text-gray-600 border-b-yellow-500": upperTab === selectedTab,
                "bg-transparent text-gray-200 border-b-gray-10": upperTab !== selectedTab
            })
        }, /*#__PURE__*/ React.createElement("button", {
            className: "block w-full text-center mx-auto py-3.5 px-1.5 md:px-3.5 focus focus-visible:-outline-offset-4 focus-visible:outline-black"
        }, upperTab === null || upperTab === void 0 ? void 0 : upperTab.title));
    }))), /*#__PURE__*/ React.createElement("main", {
        className: "pt-3.5 md:pt-7 lg:pt-14"
    }, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        key: selectedTab ? selectedTab.title : "empty",
        initial: {
            y: 10,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: -10,
            opacity: 0
        },
        transition: {
            duration: 0.2
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex lg:flex-row-reverse lg:gap-x-8"
    }, /*#__PURE__*/ React.createElement(Tab.Group, {
        vertical: true,
        selectedIndex: lowerTabIndex,
        onChange: function(index) {
            return setLowerTabIndex(index);
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:-mt-3 mb-6 md:mb-14 lg:mb-0 lg:w-1/3"
    }, /*#__PURE__*/ React.createElement(Tab.List, null, props.lowerLevelTabs.filter(function(lowerTab) {
        return (lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.parent) === visibleParentId;
    }).map(function(lowerTab, key) {
        /*#__PURE__*/ return React.createElement(Tab, {
            key: key,
            as: Fragment
        }, function(param) {
            var selected = param.selected;
            /*#__PURE__*/ return React.createElement("button", {
                className: clsx("block w-full focus focus-visible:outline-gray-300 focus-visible:-outline-offset-2 text-left transition-all font-heading font-semibold border-b border-b-gray-300 pt-3 mb-3", {
                    "text-black": selected,
                    "text-gray-300": !selected
                })
            }, lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.title);
        });
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-2/3"
    }, /*#__PURE__*/ React.createElement(Tab.Panels, null, props.lowerLevelTabs.filter(function(lowerTab) {
        return (lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.parent) === visibleParentId;
    }).map(function(lowerTab, key) {
        /*#__PURE__*/ return React.createElement(Tab.Panel, {
            className: "focus focus-visible:outline-black focus-visible:-outline-offset-2",
            key: key
        }, /*#__PURE__*/ React.createElement("div", {
            className: "rounded-l-3xl border border-gray-200 overflow-hidden bg-white"
        }, /*#__PURE__*/ React.createElement(Transition, {
            appear: true,
            show: lowerTabIndex == key,
            enter: "transition-opacity duration-500",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "transition-opacity duration-500",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "sm:flex "
        }, /*#__PURE__*/ React.createElement("div", {
            className: "sm:w-1/3"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "rounded-l-[1.4rem] w-full hidden sm:block sm:h-full bg-no-repeat bg-cover bg-center",
            style: {
                backgroundImage: "url(".concat(lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.image, ")")
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "w-full h-44 sm:hidden bg-no-repeat bg-cover bg-center",
            style: {
                backgroundImage: "url(".concat((lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.mobileImage) || (lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.image), ")")
            }
        })), /*#__PURE__*/ React.createElement("div", {
            className: "sm:w-2/3 flex flex-col justify-between"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "p-5 sm:p-8 md:min-h-[300px]"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "uppercase text-blue-500 text-xxs md:text-xs tracking-wider font-semibold block mb-2"
        }, lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.type), /*#__PURE__*/ React.createElement("h3", {
            className: "text-lg sm:text-2xl mb-0.5 md:mb-1.5 font-semibold block"
        }, lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.title), /*#__PURE__*/ React.createElement("div", {
            className: "text-sm md:text-base text-gray-200"
        }, lowerTab ? /*#__PURE__*/ React.createElement(Html, {
            markup: lowerTab.description
        }) : null)), /*#__PURE__*/ React.createElement(ArrowLink, {
            text: "Learn more",
            target: (lowerTab === null || lowerTab === void 0 ? void 0 : lowerTab.target) || "/",
            className: "px-5 md:px-7 py-4 bg-gray-10 w-full focus-visible:outline-black focus-visible:-outline-offset-2"
        }))))));
    })))))))))), /*#__PURE__*/ React.createElement("img", {
        src: "/images/block-yellow.png",
        alt: "background pattern",
        className: "absolute bottom-0 md:-bottom-[18px] -right-[36rem] md:right-0 w-[1020px] max-w-[unset]"
    }));
}
